import Tinymce from './Tinymce.vue';

export default {
  install(Vue) {
    Vue.component('Tinymce', Tinymce);
  }
};


// WEBPACK FOOTER //
// ./src/components/Tinymce/index.js